import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function IndoNepalRemittance() {
  const faqs = [
    {
      question: "What is Mokshiq Indo-Nepal Remittance API?",
      answer: "Mokshiq Indo-Nepal Remittance API (by Rakle Service Private Limited) enables cross-border money transfers from India to Nepal via direct bank transfers and cash payout counters across Nepal."
    },
    {
      question: "What documents are required for cash payout in Nepal?",
      answer: "Recipients in Nepal can collect cash payouts by presenting valid Citizenship ID, Passport, or Voter ID at authorized agent locations."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-money-bill-transfer me-2"></i>Cross-Border Remittance
            </span>
            <h1 className="page_title text-white mb-3">Indo-Nepal Money Transfer API</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Fast, secure Indo-Nepal cross-border remittance powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Fintech APIs</a></li>
              <li className="active"><a href="#!">Indo-Nepal Remittance</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-building-columns text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Direct Bank Account Credit</h3>
                  <p className="text-muted small">Real-time IMPS money deposit into commercial bank accounts across Nepal.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-hand-holding-dollar text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Instant Cash Payout</h3>
                  <p className="text-muted small">Cash collection points across all districts in Nepal for instant beneficiary cash pickup.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-shield-halved text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">RBI &amp; NRB Compliant</h3>
                  <p className="text-muted small">Fully compliant with Reserve Bank of India (RBI) and Nepal Rastra Bank (NRB) guidelines.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Indo-Nepal Remittance FAQs" subtitle="Frequently asked questions about cross-border money transfer." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default IndoNepalRemittance;
